var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gest_risorse"},[_c('main',[_vm._t("bottoni"),_vm._m(0)],2),(_vm.caricamento_dati)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"cyan","id":"progress"}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tabella"}},[_c('table',{attrs:{"id":"diagram_table"}},[_c('thead',[_c('tr'),_c('tr')]),_c('tbody')])])
}]

export { render, staticRenderFns }